import { supportLanguageList } from "./base";
// 仓位标记 接口可能返回字符串类型,从源头处做好数据格式转换
export const POSITION_LONG = 1; // 多仓
export const POSITION_SHORT = 2; // 空仓,特别注意,有些接口里空仓是0

export const SERVER_CAL_PLACE = 12; // 计算用精度,硬编码和服务端同步

export const INPUT_COUNT_LIMIT = 10000000; // 输入框可开张数硬性限制
export const DEFAULT_DECIMAL_PLACE = "8"; // 默认小数精度8

// 正则表达式
export const IntegerRegx = /^[1-9]\d*$/; // 正整数
// 模板占位符
export const TemplatePlaceholder = "{#}";
// 变精度小数正则模板
export const BaseDecimalRegxTemplate = "^(0|[1-9]\\d*)(\\.\\d{0,{#}})?$";

// 买类型方向
export const DirectionsOfBuy = [1, 4, 6, 8, 10, 12, 21, 36, 37];

export const DirectionsColorMap = {
  1: "text-contentTradeBuy",
  2: "text-contentTradeSell",
  3: "text-contentTradeSell",
  4: "text-contentTradeBuy",
  5: "text-contentTradeSell",
  6: "text-contentTradeBuy",
  7: "text-contentTradeSell",
  8: "text-contentTradeBuy",
  9: "text-contentTradeSell",
  10: "text-contentTradeBuy",
  11: "text-contentTradeSell",
  12: "text-contentTradeBuy",
  13: "text-contentTradeSell",
  14: "text-contentTradeBuy",
  15: "text-contentTradeSell",
  16: "text-contentTradeSell",
  17: "text-contentTradeSell",
  18: "text-contentTradeSell",
  19: "text-contentTradeSell",
  20: "text-contentTradeBuy",
  21: "text-contentTradeBuy",
  22: "text-contentTradeSell",
  23: "text-contentTradeBuy",
  24: "text-contentTradeSell",
  25: "text-contentTradeBuy",
  26: "text-contentTradeSell",
  29: "text-contentTradeSell",
  30: "text-contentTradeBuy",
  31: "text-contentTradeSell",
  32: "text-contentTradeBuy",
  35: "text-contentTradeSell",
  36: "text-contentTradeBuy",
  37: "text-contentTradeBuy",
  38: "text-contentTradeSell",
};

//当前委托类型
export const OneWay_delegate_type = {
  1: "delegate_type.1",
  2: "delegate_type.2",
  3: "delegate_type.3",
  4: "delegate_type.4",
  5: "delegate_type.5",
  6: "delegate_type.6",
  7: "delegate_type.7",
  8: "delegate_type.8",
  9: "delegate_type.9",
  10: "delegate_type.10",
  11: "delegate_type.11",
  12: "delegate_type.12",
  13: "delegate_type.13",
  14: "delegate_type.14",
  19: "delegate_type.19",
  20: "delegate_type.20",
  21: "delegate_type.21",
  22: "delegate_type.22",
  23: "delegate_type.23",
  24: "delegate_type.24",
  25: "delegate_type.25",
  26: "delegate_type.26",
  29: "delegate_type.29",
  30: "delegate_type.30",
  31: "delegate_type.22",
  32: "delegate_type.21",
  35: "delegate_type.35",
  36: "delegate_type.36",
  37: "delegate_type.37",
  38: "delegate_type.38",
};
// 支持的多语言
// 删除了韩语
export enum SUPPORT_LOCALES {
  en = "en",
  tr = "tr",
}

// 支持RTL的语言
export const SUPPORT_RTL_LOCALES: string[] = [];

//支持的多语言
// 删除了韩语
export const SUPPORTED_LANG = [
  ...supportLanguageList.map((item) => item.locale),
];

// 路由无语言时，默认语言
export const DEFAULT_LANG = "en";

// 新增的语言,
export const NEW_LANG = "uz";

// 支持的单位
// 删除了韩元
export const SUPPORTED_UNIT = [
  "CNY",
  "USD",
  "VND",
  "JPY",
  "TWD",
  "RUB",
  "EUR",
  "TRY",
  "IDR",
  "PHP",
  "HKD",
  "THB",
];

// 支持的主题色
export const SUPPORTED_THEME = ["dark", "light"];

// 保证金模式
export enum ContractMarginMode {
  FIXED_MARGIN = "FIXED_MARGIN",
  CROSSED_MARGIN = "CROSS_MARGIN",
}

// 保证金模式请求参数使用的数值
export const ContractMarginModeNumber = {
  [ContractMarginMode.FIXED_MARGIN]: 1,
  [ContractMarginMode.CROSSED_MARGIN]: 2,
};

/**
 * 基本的账户ID
 */
export enum Site {
  Spot = 1,
  Leverage = 2, // 已废弃
  Contract = 3,
  OTC = 4,
  Mix = 5, // 暂不使用
  USDT_MIX = 6,
  USD_MIX = 7,
}

// 下拉选择中的宣布选项，均用该值作为key
export const KeyOfOptionAll = "all";

export const LanguageTypeMap = supportLanguageList.reduce(
  (pre, cur) => {
    return { ...pre, [cur.locale]: cur.languageType };
  },
  { sk: 0 }
);

export const LanguageKeyMap = supportLanguageList.reduce(
  (pre, cur) => {
    return { ...pre, [cur.locale]: cur.languageKey };
  },
  { sk: "en_US" }
);

export const LanguageHeaderMap = supportLanguageList.reduce(
  (pre, cur) => {
    // const value = cur.languageKey === 'en_GB' ? 'ko_KR' : cur.languageKey
    return { ...pre, [cur.locale]: cur.languageKey };
  },
  { sk: "bg_BG" }
);

/**
 * 合约单位枚举（注意：已经和用户偏好设置中的contractUnitSet字段统一）
 */
export enum TradeUnitEnum {
  BASE_SYMBOL = 0,
  MARGIN_SYMBOL = 1, // 成本价值
  PRICED_SYMBOL = 2, // 名义价值
}

/**
 * 单双向持仓模式选择
 * 数值待确认
 */
export enum PositionModeEnum {
  ONE_WAY = 1, // 单向持仓
  TWO_WAY = 2, // 双向持仓
}
/**
 * 涨跌幅、k线等周期选择
 * 目前只在本地保存
 */
export enum TimezoneEnum {
  UTC = 0,
  SHANGHAI = 1,
}

/**
 * 永续合约里面的做市币对分类
 *
 */
export enum PerpetualSceEnum {
  DEFAULT = 1,
  INNOVATION = 2,
}

/**
 * TDK 默认值
 * title: Cointr-Trade smarter
 * description: View live crypto trading exchange chart to track the latest price and market movement.
 */
export const DEFAULT_TDK = {
  title: "Cointr-Trade smarter",
  description:
    "View live crypto trading exchange chart to track the latest price and market movement.",
};

/**
 * KYC 验证失败code
 */
export const KYC_FAIL_CODES = ["23126", "24391"];

export {};

/**
 * 页面布局方向
 */
export enum Dir {
  RTL = "rtl",
  LTR = "ltr",
}

// 演示demo 账户状态
export enum UserDemoType {
  DemoDefault = "0",
  DemoStatus = "1",
  CreationDemoAccount = "2",
}

// 通知中心 notification key
export const NOTIFICATION_CENTER_SINGLE_KEY = "NOTIFICATION_CENTER_SINGLE_KEY";

// adl 展示开关状态
export enum ADL_STATUS {
  OPEN = 1,
  CLOSE = 0,
}

// usdt 联合保证金相关枚举
export enum USDT_ASSET_MODE_TYPE {
  // 单币对模式
  SINGLE_MODE = 1,
  // 多币对模式
  UNION_MODE = 2,
}

// tab类型
export enum TabType {
  Chart = 1,
  Profile,
  CoinOverview,
  PastPerformance,
  News,
}
